import { render, staticRenderFns } from "./SettingsUnified.vue?vue&type=template&id=469ec8c9&scoped=true&"
import script from "./SettingsUnified.vue?vue&type=script&lang=js&"
export * from "./SettingsUnified.vue?vue&type=script&lang=js&"
import style0 from "./SettingsUnified.vue?vue&type=style&index=0&id=469ec8c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469ec8c9",
  null
  
)

export default component.exports